import flatpickr from 'flatpickr';
import type { key as LocaleKey } from 'flatpickr/dist/types/locale';
import type { Hook, Options } from 'flatpickr/dist/types/options';
import FlatpickrLanguages from 'flatpickr/dist/l10n/index';
import 'flatpickr/dist/themes/light.css';

type Params = {
	target: Node;
	onChange?: Hook;
	defaultDate: string | Date;
	onReady?: Hook;
	time?: boolean;
	range?: boolean;
	minDate?: Date;
	maxDate?: Date;
	onClose?: Hook;
	lang: string;
	inline?: boolean;
};

const createCalendar = (params: Params) => {
	const {
		target,
		defaultDate,
		onChange,
		onReady,
		onClose,
		time,
		range,
		minDate,
		maxDate,
		lang,
		inline = false,
	} = params;
	const mode: 'single' | 'multiple' | 'range' | 'time' = range ? 'range' : 'single';
	const lang2 = lang.slice(0, 2);
	const locale = (lang2 in FlatpickrLanguages ? lang2 : 'en') as LocaleKey;
	const options = {
		onClose,
		onChange,
		onReady,
		locale,
		defaultDate,
		mode,
		minDate,
		maxDate,
		time_24hr: true,
		showMonths: range ? 2 : 1,
		enableTime: time || false,
		inline,
	} satisfies Options;
	return flatpickr(target, options);
};

export default createCalendar;
